import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import SearchBar from './SearchBar';
import { SET_SEARCH_QUERY } from '../../redux/Table';

class SearchBarContainer extends Component {
  constructor(props) {
    super(props);
    this.debouncedOnSearchClick = debounce(props.onSearchClick, props.delay);
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.onSearchClick !== this.props.onSearchClick) {
      this.debouncedOnSearchClick = debounce(nextProps.onSearchClick, nextProps.delay);
    }
  };

  onInputChange = (e) => {
    const newValue = e.target.value;
    const { delay, onSearchClick, setQuery, tableName } = this.props;
    setQuery({ tableName, queryValue: newValue });
    if (delay) {
      this.debouncedOnSearchClick();
    } else {
      onSearchClick();
    }
  };

  render() {
    const { value } = this.props;
    return (
      <SearchBar
        onInputChange={this.onInputChange}
        value={value}
      />
    );
  }
}
SearchBarContainer.propTypes = {
  onSearchClick: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  delay: PropTypes.number,
  value: PropTypes.string,
};

SearchBarContainer.defaultProps = {
  delay: 0,
  value: '',
};

const mapStateToProps = (state, ownProps) => {
  return {
    value: get(state, ['tables', ownProps.tableName, 'queryValue']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { setQuery: payload => dispatch(SET_SEARCH_QUERY(payload)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarContainer);
